<template>
    <div class="meals">
        <section class="home-cards">
        <!-- <hr class="hr"> -->
        <div class="healthy">
          <div class="image-head">
            <img src="@/assets/lunch.jpg" alt="school lunch">
          </div>
          <h4>SCHOOL MEALS</h4>
          <p>We believe in Healthy Eating.
          We believe that improved health, social and cognitive development cannot be achieved without good nutrition. Poorly nourished children cannot grow and develop optimally, resist infection, learn to their full potential or overcome social, emotional or behavioural difficulties. For this reason, a huge amount of importance is placed on the diet at Inspire Leadership School (ILS).</p>
        </div>
        <h6>Lunch Menu</h6>
        <div class="home-cards-main">
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/logo.svg" alt="logo">
                </div>

                <div class="feature-detail">
                  <table>
                    <tr>
                        <th>DAY</th>
                        <th>MEAL</th>
                    </tr>
                    <tr>
                        <td>Monday</td>
                        <td>RICE WITH BEEF STEW</td>
                    </tr>
                    <tr>
                        <td>Tuesday</td>
                        <td>NSHIMA WITH CHICKEN AND SEASONAL VEGETABLE</td>
                    </tr>
                    <tr>
                        <td>Wednesday</td>
                        <td>MACARONI AND SAUSAGE</td>
                    </tr>
                    <tr>
                        <td>Thursday</td>
                        <td>NSHIMA WITH BEANS AND SEASONAL VEGETABLE</td>
                    </tr>
                    </table>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'Meals',
  components: { }
}
</script>

<style>
.meals .healthy .image-head {
  margin-bottom: 2em;
}
.meals .healthy p {
  color: white;
  font-size: 1.4em;
}
.meals .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.meals .home-cards .home-cards-main {
  padding: 1em;
  max-width: 800px;
  margin: 10px auto;
  background-color: var(--inspire-gold);
}
.meals .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.meals .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.meals .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.meals .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.meals .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
.meals .feature .feature-detail table {
  width: 100%;
  border: 1px solid black;
}
.meals .feature .feature-detail table td {
  border: 1px solid black;
}
</style>
